const getTimeZoneOffset = () => {
  const date = new Date()
  const offset = -(date.getTimezoneOffset() * 60)

  return offset
}

export default getTimeZoneOffset
